import { cymbioColors } from '../../../utils/colors';

export const REPORTS_MANAGER_TYPES = {
  inventory: 'inventory',
  orders: 'orders',
  pricing: 'pricing',
};

export const REPORTS_MANAGER_TYPES_DISPLAY_NAME = {
  [REPORTS_MANAGER_TYPES.inventory]: 'Inventory',
  [REPORTS_MANAGER_TYPES.orders]: 'Orders',
  [REPORTS_MANAGER_TYPES.pricing]: 'Pricing',
};

export const REPORTS_MANAGER_STATUSES = {
  ready: 'ready',
  processing: 'processing',
  failed: 'failed',
};

export const ReportsManagerStatuses = {
  ready: {
    label: 'Ready',
    color: cymbioColors.analytics.lime,
  },
  processing: {
    label: 'Processing',
    color: cymbioColors.analytics.sunset,
  },
  failed: {
    label: 'Failed',
    color: cymbioColors.analytics.ruby,
  },
};

export const reportsManagerColumns = {
  type: { label: 'Type', canBeSorted: true },
  'reportFile.name': { label: 'Name', canBeSorted: true },
  'reportFile.size': { label: 'Size', canBeSorted: true },
  createdAt: { label: 'Date', canBeSorted: true },
  status: { label: 'Status', canBeSorted: true, style: 'status' },
  actions: { style: 'actions' },
};
